<template>
	<label :for="id" class="text-dark-gray-3 text-base	 flex flex-start items-center ">
		<input type="radio"
		       class="rounded-full mx-2  w-[14px] h-[14px]
			   !ring-offset-0 !ring-0 hover:bg-inherit
			   checked:border-2 checked:border-white
			   checked:outline checked:outline-1 checked:outline-primary
			   hover:checked:!border-white focus:checked:!outline-offset-0 focus:checked:outline-1 
			   focus:checked:border-2 focus:checked:border-white
			   checked:!bg-primary checked:bg-[length:0]" 
		       :id="id"
		       :value="value"
		       :checked="checked"
			   :class="{'disabled':disabled, extraClasses }"
		       v-model="model"
			   :required="required"
			   :name="name"
			   :disabled="disabled">
		<slot></slot>
	</label>
</template>

<script>
export default {
	name: "default-radio",
	props: {
		name: String,
		id: String,
		value: [String, Number],
		checked: {
			type: Boolean,
			default: false
		},
		extraClasses: [String, Array],
		modelValue: [String, Number],
		required: Boolean,
		disabled: Boolean
	},
	computed: {
		model: {
			get() { return this.modelValue },
			set(newValue) { this.$emit('update:modelValue', newValue)}
		}
	}
}
</script>

<style scoped>
[type='radio']:disabled {
    @apply grayscale bg-slate-400
}
</style>